var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRubyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15045_6787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8087 18.6278C22.8008 14.4362 24.4642 9.46211 22.4681 7.56191C20.4721 5.66171 15.6483 7.50603 11.6563 11.6976C7.66419 15.8893 6.00082 20.8633 7.94142 22.7635C9.88201 24.6637 14.8167 22.8194 18.8087 18.6278Z",
    fill: "white",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5566 10.4681C33.2239 8.90319 32.3368 7.78542 30.8398 7.22654C29.0655 6.55588 27.1804 6.83532 25.3507 6.89121C25.1289 6.89121 24.9071 7.00299 24.7962 7.17065L24.8516 7.56187C24.8516 7.61776 24.8516 7.61776 24.8516 7.67365L25.4061 10.8593L22.4675 18.013L14.1507 25.1667L8.77244 25.6697L7.10907 23.5459C7.05363 23.5459 6.99818 23.5459 6.88729 23.6018C6.49917 23.6577 6.49917 24.0489 6.44373 24.3842C6.38828 25.1667 6.33283 26.005 6.27739 26.7874C6.22194 27.4022 6.1665 28.017 6.1665 28.6317C6.05561 32.1527 8.05165 34.3323 11.5447 34.3323C12.3764 34.3323 13.1526 34.3323 13.9843 34.2764C17.3111 34.0529 20.6378 33.8293 23.9645 33.6058C26.4041 33.4381 28.7883 33.2705 31.2279 33.1028C31.6714 33.0469 32.115 33.0469 32.1705 32.3762C32.614 26.005 33.1685 19.6896 33.612 13.3184C33.7784 12.2565 33.7229 11.3623 33.5566 10.4681Z",
    fill: "white",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2829 23.2665L30.6176 30.9791L24.0195 31.4262L31.2829 23.2665Z",
    fill: "#1A22E4",
    stroke: "#465C6F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15045_6787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyIcon);
export default __webpack_public_path__ + "static/media/ruby-icon.584ea3141d05ad4a766d49e6ad59c2b9.svg";
export { ForwardRef as ReactComponent };